import React from 'react';

export default function CardImagePlaceholder(): JSX.Element {
  return (
    <div className="placeholder-glow" style={{ display: 'flex' }}>
      <div className="placeholder" style={{ width: '100%', aspectRatio: '0.75', flexGrow: '1' }} />
    </div>
  );
}
